<template>
  <div id="app">
    <meta name="referrer" content="no-referrer" />
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import DevicePixelRatio from "@/directives/DevicePixelRatio.js";
import commoninfoStore from "@/store/commonin";
import metaInfoStore from "@/store/metaStore";
import { useRouter, useRoute } from "vue-router";
import { useMeta } from 'vue-meta';
const commoninfo = commoninfoStore();
const metaInfoS = metaInfoStore();
let router = useRouter();
let route = useRoute();

// const metaInfo = {
//       title: metaInfoS.title,
//       keywords: metaInfoS.keywords,
//       description: metaInfoS.description,
//     }
//   useMeta({
//   ...metaInfo
// });


const bodyScale = () => {
  var devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
  var scale = devicewidth / 1920; // 分母——设计稿的尺寸
  console.log("scale", scale);

  document.body.style.zoom = scale; //放大缩小相应倍数
};

// 监听页面宽度
const pageWidth = ref(window.innerWidth);
const handleResize = () => {
  let test = JSON.parse(localStorage.getItem("commoninfo"));
  // console.log("test", test.changeToMobileWidth);
  if (commoninfo.changeToMobileWidth != 832) {
    localStorage.setItem("changeToMobileWidth", 832);
    commoninfo.setChangeToMobileWidth(832)
  }
  if (commoninfo.language != "en") {
    localStorage.setItem("changeToMobileTopMenuWidth", 1080);
    commoninfo.setChangeToMobileTopMenuWidth(1080)
  }
  if (commoninfo.language == "en") {
    localStorage.setItem("changeToMobileTopMenuWidth", 1150);
    commoninfo.setChangeToMobileTopMenuWidth(1150)
  }
  pageWidth.value = window.innerWidth;
  console.log("pageWidth.value", pageWidth.value);
  console.log("commoninfo.changeToMobileWidth", commoninfo.changeToMobileWidth);
  console.log("是否是横屏", window.innerWidth > window.innerHeight);
  commoninfo.setPageWidth(window.innerWidth);

  if (pageWidth.value <= commoninfo.changeToMobileWidth) {
    console.log("修改修改修改Mobile");
    commoninfo.setmenChangepath("mobile");
    localStorage.setItem("change_path", "mobile");
    // commoninfo.setShowMessageCard(false);
  } else {
    // console.log("修改修改修改Pc");
    // commoninfo.setmenChangepath("pc");
    // localStorage.setItem("change_path", "pc");
    // // commoninfo.setShowMessageCard(true);
    if (window.innerWidth > window.innerHeight) {
      console.log("修改修改修改Pc111");
      commoninfo.setmenChangepath("pc");
      localStorage.setItem("change_path", "pc");
    } else {
      console.log("修改修改修改Mobile111");
      commoninfo.setmenChangepath("mobile");
      localStorage.setItem("change_path", "mobile");
      commoninfo.setShowMessageCard(false);
    }
  }

  console.log("pcMobile-app监听", commoninfo.change_path);
};

// if (test.changeToMobileWidth == 1280 || test.changeToMobileWidth == "1280") {
//   commoninfo.changeToMobileWidth = 832;
// }
// localStorage.setItem("commoninfo", "");
onMounted(() => {
  // new DevicePixelRatio().init();
  // bodyScale();
  if (commoninfo.change_path == "pc") {
    commoninfo.setShowMessageCard(true);
  } else {
    commoninfo.setShowMessageCard(false);
  }
  commoninfo.setShowMessageCardFirst(true);
  commoninfo.setDrawerOpenLang(false);
  commoninfo.setDrawerOpenMain(false);

  handleResize(); // 初始检查
  window.addEventListener("resize", handleResize);
});
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<style>
@import "@/assets/css/base";
@import "./assets/iconfont/iconfont.css";
/* #app {
  font-family: "Microsoft YaHei", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */
</style>
